import { render } from "./DonationForm.vue?vue&type=template&id=0599bc41&ts=true"
import script from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/style-two/DonationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0599bc41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0599bc41', __exports__)) {
    api.reload('0599bc41', __exports__)
  }
  
  module.hot.accept("./DonationForm.vue?vue&type=template&id=0599bc41&ts=true", () => {
    api.rerender('0599bc41', render)
  })

}


export default __exports__